document.addEventListener("click", function (event) {
  if (
    event.target.matches(".card_atc_btn") ||
    event.target.closest(".card_atc_btn")
  ) {
    const target = event.target.matches(".card_atc_btn")
      ? event.target
      : event.target.closest(".card_atc_btn");
    const id = parseInt(target.getAttribute("data-variant"));
    const discountedPriceMoney = target.dataset.discountedPriceMoney;
    target?.classList.add("loading");
    window.updateCartDrawer(id, target,discountedPriceMoney);
    document.querySelector("#cart-icon-bubble")?.click();
  }
});
window.updateCartDrawer = function (id, target,discountedPriceMoney) {
  if (id) {
    function getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
    // console.log("Matched Variant:", currentVariant);
    const config = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
    };

    const sectionsToRender = [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cartIconBubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-section",
      },
    ];

    let formData = new FormData();
    formData.append("id", id);
    formData.append("quantity", 1);
    formData.append("properties[Discounted Price]", discountedPriceMoney);
    formData.append(
      "sections",
      sectionsToRender.map((section) => section.section)
    );
    formData.append("sections_url", window.location.pathname);
    config.body = formData;
    console.log("formData", formData);

    fetch(`/cart/add`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.message);
          return;
        }

        const product = response.hasOwnProperty("items")
          ? response.items[0]
          : response;
        document.querySelector("cart-drawer")?.classList.remove("is-empty");
        target?.classList.remove("loading");
        // document.querySelector(".mobile_size_swatch_popup")?.remove();
        sectionsToRender.forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          // console.log('sectionElement' , sectionElement)
          if (sectionElement) {
            sectionElement.innerHTML = getSectionInnerHTML(
              response.sections[section.section],
              section.selector
            );
          }
        });
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  } else {
    console.log("No matching variant found.");
  }
};
